import React from 'react';
import {
  FileUploadAPIType,
  MatchedNodeType,
  CurrentResponseType,
  CurrentLanguageType,
  LabelInternationalizationType
} from 'src/Components/FeatureComponents/Response/Model';

export const truthyOrFalsy = someValue => {
  if (typeof someValue === 'string')
    if (someValue.length === 0) return !!someValue;
    else return !(someValue.toLowerCase() === 'false');

  if (typeof someValue === 'number') return !!someValue;

  if (typeof someValue === 'boolean') return someValue;

  if (typeof someValue === 'object' || typeof someValue === 'function')
    return true;

  if (typeof someValue === void 1) return false;
};

export const FileUploadContext = React.createContext<FileUploadAPIType>({
  fileSizeAmount: 0,
  fileSizeUnit: 1,
  fileUploadAPI: '',
  fileSubType: [],
  typeId: 0
});
export const MatchedNodeContext = React.createContext<MatchedNodeType>({
  taskId: 0,
  workflowId: 0,
  botId: 0
});

export const CurrentResponseContext = React.createContext<CurrentResponseType>({
  typeName: '',
  setType: () => {}
});

export const CurrentLanguageContext = React.createContext<CurrentLanguageType>({
  languageCode: 'en',
  updateLanguageCode: () => {}
});

export const LanguageContext = React.createContext<{ [k: string]: string }>({});

export const InternationalizationContext = React.createContext<{
  currentLanguage: string;
  data: LabelInternationalizationType | null;
}>({ currentLanguage: 'en', data: null });
